import cn from 'classnames'
import type { ReactNode } from 'react'

import styles from './CockpitCollapsedMetricValue.module.scss'

interface ICockpitCollapsedMetricValueProps {
  children: ReactNode
  className?: string
  secondary?: boolean
}

export const CockpitCollapsedMetricValue = ({
  children,
  className,
  secondary = false,
}: ICockpitCollapsedMetricValueProps) => (
  <span className={cn(styles.root, className, { [styles.secondary]: secondary })}>{children}</span>
)

CockpitCollapsedMetricValue.displayName = 'CockpitCollapsedMetricValue'
